export default __webpack_public_path__ + "static/media/log.f455fc91.png";